import * as angular from "angular";
import {IController, IRootScopeService} from "angular";
import * as _ from "lodash";
import {RouteRequestsService} from "../../services/routes-requests.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {TaskModel} from "../../../tasks/models/task.model";

export class RoutePanelCtrl implements IController {
  route: any;
  createCircles: any;
  showMarkers: Function;
  onClose: Function;

  public showTab: any;
  public suggestedDeliveries: any;
  public working: any;
  public selectedTask: any;
  public tabs: any;
  public canRemove: boolean;
  public canAdd: boolean;

  constructor(private confirmDialogService: ConfirmDialogService, private routeRequestsService: RouteRequestsService, private mapConstant, private $log,
              private $scope, private $rootScope: IRootScopeService, private $delivery, private deliveriesConstants) {
  }


  $onInit() {
    this.$rootScope.$on('highlight-stopover-from-marker', (event, taskId) => {
      this.selectTask(taskId)
    });

    this.tabs = ['Deliveries', 'Tasks', 'Suggestions'];
    this.showTab = this.tabs[0];
  }

  getSuggestions() {
    this.suggestedDeliveries = [];

    this.working = true;

    this.routeRequestsService.getSuggestedDeliveries(this.route.id)
      .then((res: any) => {
        this.suggestedDeliveries = res;
        this.working = false;
        let tasks = [];
        _.map(res, (del: any) => {
          del.taskList.forEach((task: TaskModel) => {
            tasks.push(task);
          });
        });
        this.$rootScope.$emit(this.mapConstant.events.siteMarket.displaySuggestedMarkers, tasks);
      });
  }

  selectDelivery(deliveryId) {
    this.$delivery(deliveryId).$asyncValue()
      .then((delivery) => {
        this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.stopAllMarkersBounce);
        this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.taskMarkersBounce, delivery.taskIdList);
        this.$rootScope.$broadcast('highlight-stopover-from-delivery', delivery.taskIdList[0]);
      })
      .catch((error) => {
        this.$log.error('Failed to get delivery, ' +
          'routePanel@selectDelivery' + error);
      })
  }

  selectTask(taskId) {
    this.selectedTask = taskId;
    this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.taskMarkersBounce, [taskId]);
  }

  selectTab(tab) {
    this.showTab = tab;

    if (tab === 'Suggestions') {
      this.getSuggestions();
    } else {
      this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.removeSuggestedMarkers)
    }
    this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.stopAllMarkersBounce);
  }

  addSuggestedDel(delivery) {
    this.working = true;
    this.routeRequestsService.addDeliveriesToRoute([delivery.id], this.route.id).then(
      (updatedRoute) => {
        this.working = false;
        this.route = updatedRoute;
        this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.removeSuggestedMarkers);
        this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.removeDeliveryTaskMarkers);
        this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.displayDeliveryTaskMarkers, updatedRoute.serviceIdList);
        this.$scope.createCircles([updatedRoute.rid]);
        this.getSuggestions();
      },
      (error) => {
        this.$log.error('Failed to add delivery to route, ' +
          'routePanel@addSuggestedDel' + error)
      }
    );
  }

  checkIfCanRemove() {
    let can = true;
    if (_.get(this.route, 'serviceIdList.length') < 2) {
      can = false;
    }
    if (_.get(this.route, 'status') === this.deliveriesConstants.status.Assigned) {
      can = false;
    }
    this.canRemove = can;
  }

  checkIfCanAdd() {
    let can = true;

    if (_.get(this.route, 'status') === this.deliveriesConstants.status.Assigned) {
      can = false;
    }
    this.canAdd = can;
  }

  removeSuggestedDel(event, serviceId) {
    this.confirmDialogService.confirm("Remove Route", "Are you sure you want to remove route #" + serviceId, event).then(
      () => {
        this.working = true;
        this.routeRequestsService.removeDeliveryFromRoute([serviceId], this.route.id).then(
          (updatedRoute) => {
            this.working = false;
            this.route = updatedRoute;
            this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.removeSuggestedMarkers);
            this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.removeDeliveryTaskMarkers);
            this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.displayDeliveryTaskMarkers, updatedRoute.serviceIdList);
            this.createCircles([updatedRoute.rid]);
          },
          (error) => {
            this.$log.error('Failed to remove delivery from route, ' +
              'routePanel@removeSuggestedDel' + error)
          }
        )
      },
      () => {
        this.$log.info('Closed Dialog');
      }
    )
  }


}

angular
  .module('bringoz.admin.routes')
  .component('routePanel', {
    bindings: {
      route: '<',
      createCircles: '<?',
      showMarkers: '&',
      onClose: '&',
    },
    template: require('./route-panel.html').default,
    controller: RoutePanelCtrl
  });
